<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <ion-item class="ion-margin-bottom" lines="none">
            <ion-label position="floating">Complete before: </ion-label>
            <h4>{{ new Date(date).toDateString() }}</h4>
          </ion-item>
        </ion-col>

        <ion-col size="12">
          <list-chapter-progression
            :resources="resources"
            :description="description"
          ></list-chapter-progression>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import ListChapterProgression from "../../Components/Academic/Subject/ListChapterProgression.vue";

import {
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,

} from "@ionic/vue";

export default {
  props: ["chapter", "description"],
  components: {
    BaseLayout,
    ListChapterProgression,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Chapter Progression",
      date: null,
      chapter_id: this.chapter,
      backLink: "academic",
      reloadable: true,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["chapterProgression/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },


  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = true) {
      await this.$store.dispatch("chapterProgression/resources", {
        refresh: refresh,
        resourceId: this.chapter,
      });
    },
    loadData(event) {
      this.fetch(false);
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("chapterProgression/resources", {
        refresh: true,
        resourceId: this.chapter,
      });
      if (event) {
        event.target.complete();
      }
    },

    initDate() {
      const data = this.resources.data;
      if (!Array.isArray(data) || data.length < 1) {
        this.date = "Not Set"
        return;
      }
      const progressions = data[0].chapter_progressions;
      if (!Array.isArray(progressions) || progressions.length < 1) {
        this.date = "Not Set"
        return;
      }
      const first_date = progressions[0].complete_before;
      this.date = first_date;
    },
  },

  async created() {
    await this.fetch();
    this.initDate();
  },

  updated() {
    this.initDate()
  },
};
</script>

<style scoped>
</style>
